import z from 'zod';

import { MatchingRecord } from '@eluve/utils';

import { TranscriptTypesEnum, TranscriptionStatusEnum } from './types';

export const TranscriptTypesLookup = {
  BATCH: 'BATCH',
  LIVE: 'LIVE',
  CHUNKED_BATCH: 'CHUNKED_BATCH',
} as const satisfies MatchingRecord<TranscriptTypesEnum>;

export const TranscriptStatusLookup = {
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  IN_PROGRESS: 'IN_PROGRESS',
  NOT_STARTED: 'NOT_STARTED',
  PENDING_AUDIO: 'PENDING_AUDIO',
  PRE_PROVISIONED: 'PRE_PROVISIONED',
  CANCELLED: 'CANCELLED',
} as const satisfies MatchingRecord<TranscriptionStatusEnum>;

export const TranscriptTypeSchema = z.nativeEnum(TranscriptTypesLookup);
